<template>
  <ButtonView type="link" color="foreground" :route="canViewThisPlayer ? playerRoute : undefined" :style="!canViewThisPlayer ? { 'pointer-events': 'none' } : {}">
    <div class="d-flex align-items-center g-2">
      <AvatarView :url="player.avatarUrl"/>
      <span class="text-start">{{ player.name }}</span>
    </div>
  </ButtonView>
</template>

<script setup>
import {ButtonView} from "@/niftybit";
import AvatarView from "@/components/global/AvatarView.vue";
import {computed} from "vue";
import authorization from "@/authorization";

const props = defineProps({
  player: Object
});

const canViewThisPlayer = computed(() => authorization.permission('community.players.view'));
const playerRoute = computed(() => ({ name: "community.player", params: { playerId: props.player.id }}));

</script>

<style scoped>

</style>
